var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "search__form" }, [
      _c("span", { staticClass: "search__title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("div", { staticClass: "search__inputs" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.query,
              expression: "query",
            },
          ],
          ref: "inputQuery",
          staticClass: "input",
          attrs: { type: "text", placeholder: "Smart Media Insights" },
          domProps: { value: _vm.query },
          on: {
            keyup: _vm.doSearch,
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.query = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass:
              "p-1 text-argus-primary hover:text-argus-accent transition-colors cursor-pointer",
          },
          [_c("ag-icon", { attrs: { icon: "search", size: "23" } })],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "search__close",
          on: {
            click: function ($event) {
              return _vm.$emit("close-menu")
            },
          },
        },
        [_c("ag-icon", { attrs: { icon: "x", size: "28" } })],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "search__results" }, [
      _c("span", { staticClass: "search__results-left" }),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "search__results-loading" },
            [_c("ag-loading")],
            1
          )
        : _vm.data !== null && _vm.data.length === 0
        ? _c("div", [_vm._v("\n      " + _vm._s(_vm.noResults) + "\n    ")])
        : _c(
            "div",
            { staticClass: "search__list" },
            _vm._l(_vm.data, function (result) {
              return _c("div", { key: result.id, staticClass: "search-item" }, [
                _c(
                  "a",
                  {
                    staticClass: "search__list-item",
                    attrs: { href: result.url },
                  },
                  [
                    _c("p", {
                      staticClass: "search__item-title",
                      domProps: { innerHTML: _vm._s(result.title) },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "search__item-content" }, [
                      _c("p", [
                        _vm._v(
                          "\n              " +
                            _vm._s(result.search_excerpt) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        { staticClass: "button", attrs: { type: "button" } },
                        [
                          _vm._v(
                            "\n              " + _vm._s("Go") + "\n            "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ])
            }),
            0
          ),
      _vm._v(" "),
      _c("span", { staticClass: "search__results-right" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }